const CORES_WITH_VISIT_HISTORY = [
  'NUC RIBEIRAO PRETO DOM'
];

export const isAuthorizedCore = (core) => {
  return CORES_WITH_VISIT_HISTORY.includes(core);
};
